// extracted by mini-css-extract-plugin
module.exports = {"span":"Tooltip_span__Ow1oM","titleTab":"Tooltip_titleTab__SeP_e","titleCheckbox":"Tooltip_titleCheckbox__TuFwo","spanDp":"Tooltip_spanDp__F_EzR","close":"Tooltip_close__0rCC0"};